import { z } from 'zod'
import { zDecimal, zId, zIsoDate } from '../common'

// An affiliate network (Kwanko, TimeOne, Awin…) attached to one property. The
// tenantId is inherited from the parent property, never read from the body.
// Network credentials are never exposed (read or write) — do not build a form
// for them.
export const zAffiliatePartner = z.object({
  id: zId,
  tenantId: zId,
  propertyId: zId,
  partnerName: z.string(),
  label: z.string().nullable(),
  commissionRate: zDecimal,
  baseUrl: z.string().nullable(),
  status: z.string(),
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type AffiliatePartner = z.infer<typeof zAffiliatePartner>
